import React, { Component } from 'react';
import { SelectionPickDialog } from 'src/ui/library/Dialog';
import intl from 'react-intl-universal';
import { Card, CardContent } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

class SelectRolePres extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userPickedRole: 'Corp',
    };
  }

  handleRoleChange = event => {
    console.log('clicked');
    this.setState({
      userPickedRole: event.target.value,
    });
  };

  getSelectionDialogContent = (selectionGroups, instructionNote) => {
    return (
      <div>
        {selectionGroups.map(x => (
          <Card className="dual-role-dialog">
            <CardContent className="dual-role-dialog content">
              <h3 className="dual-role-dialog title">{x.title}</h3>
              <div className="dual-role-dialog divider" />
              <div className="dual-role-dialog radio-pick">
                <FormControlLabel
                  value={x.value}
                  checked={this.state.userPickedRole === x.value}
                  control={<Radio disableRipple checkedIcon={<CheckCircleIcon style={{ color: 'black' }} />} />}
                  label={<span dangerouslySetInnerHTML={{ __html: x.bodyText }} className="dual-role-dialog radio-label" />}
                  onChange={this.handleRoleChange}
                />
              </div>
            </CardContent>
          </Card>
        ))}
        <p className="prompt-text">{instructionNote}</p>
      </div>
    );
  };

  render = () => {
    const { isOpen } = this.props;
    const selectionGroups = [
      {
        title: intl.get('login.dualRoleSelection.corpRolePanelTitle'),
        bodyText: intl.get('login.dualRoleSelection.corpRolePanelBodyText'),
        value: 'Corp',
      },
      {
        title: intl.get('login.dualRoleSelection.employeeRolePanelTitle'),
        bodyText: intl.get('login.dualRoleSelection.employeeRolePanelBodyText'),
        value: 'Employee',
      },
    ];
    const instructionNote = intl.get('login.dualRoleSelection.instructionNote');
    const selectionDialogContent = this.getSelectionDialogContent(selectionGroups, instructionNote);

    return (
      <SelectionPickDialog
        open={isOpen}
        title={intl.get('login.dualRoleSelection.title')}
        confirmText={intl.get('login.dualRoleSelection.confirmText')}
        onConfirm={() => this.props.selectRole(this.state.userPickedRole)} // go back to loginSaga to update BE context once finishing selection and redirect to dashboard url
        noCancel={true}>
        {selectionDialogContent}
      </SelectionPickDialog>
    );
  };
}

export default SelectRolePres;
